var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"0 auto","max-width":"610px"}},[_c('div',{staticClass:"p-4"},[_c('h2',{staticClass:"form-title"},[_vm._v("Novos horários")]),_c('NewSlotSimpleForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }